import React, { useRef, useState, useEffect } from "react";
import styles from "./Otp.module.css";
import Button from "@mui/material/Button";
import { CloseFullscreen } from "@mui/icons-material";
import { FormControl, FormHelperText } from "@mui/material";

function Otp({
  length = 6,
  onChangeOTP,
  OtpError,
  error,
  handleResend,
  description,
  errormessage,
  handleVerify,
  helperText,
  showVerifyButton,
  showResendButton,
  BoxSize,
}) {
  const [otp, setOtp] = useState(Array(length).fill(""));
  const inputsRef = useRef([]);

  useEffect(() => {
    inputsRef.current[0]?.focus();
  }, []);

  const handleChange = (value, index) => {
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < length - 1) {
      inputsRef.current[index + 1]?.focus();
    }

    onChangeOTP?.(newOtp.join(""));
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const newOtp = [...otp];

      if (otp[index]) {
        newOtp[index] = "";
        setOtp(newOtp);
        onChangeOTP?.(newOtp.join(""));
      } else if (index > 0) {
        newOtp[index - 1] = "";
        setOtp(newOtp);
        inputsRef.current[index - 1]?.focus();
        onChangeOTP?.(newOtp.join(""));
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const data = e.clipboardData.getData("text").replace(/\D/g, "");
    if (data.length <= length) {
      const newOtp = data.split("").slice(0, length);
      const filled = [...otp];
      for (let i = 0; i < newOtp.length; i++) {
        filled[i] = newOtp[i];
      }
      setOtp(filled);
      onChangeOTP?.(filled.join(""));
    }
  };

  return (
    <>
      <div className={styles.OtpContainer}>
        <div className={styles.OtpInputContainer}>
          <div className={styles.OtpInput}>
            <div className={OtpError}>
              <div
                style={{ display: "flex", gap: "1px" }}
                onPaste={handlePaste}
              >
                {/* {otp.map((data, i) => {
                return (
                  <input
                    type="text"
                    value={data}
                    maxLength={1}
                    onChange={(e) => handleChange(e, i)}
                  />
                );
              })} */}

                {otp.map((digit, i) => (
                  <input
                    key={i}
                    ref={(el) => (inputsRef.current[i] = el)}
                    type="text"
                    maxLength="1"
                    value={digit}
                    onChange={(e) => handleChange(e.target.value, i)}
                    onKeyDown={(e) => handleKeyDown(e, i)}
                    style={{width:BoxSize, height:BoxSize}}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {error && 
      <FormControl error={error} fullWidth>
        {" "}
        {helperText && (
          <FormHelperText id="component-helper-text" sx={{ marginLeft: "0" }}>
            {helperText}
          </FormHelperText>
        )}
      </FormControl>
      }

      {errormessage && (
        <div>
          <div className={styles.OtpErrorMessage}>
            <span className="ErrorMessage">{errormessage}</span>
          </div>
          <div className={styles.Desription}>{description}</div>
          <div>
            {showVerifyButton && (
              <Button
                className={styles.VerifyButton}
                variant="text"
                onClick={handleVerify}
                sx={{ textTransform: "initial" }}
              >
                Verify
              </Button>
            )}
            {showResendButton && (
              <Button
                className={styles.ResendButton}
                variant="text"
                onClick={handleResend}
              >
                Resend Code
              </Button>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default Otp;
